import { Text } from '@wegroup/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';
import { getTagContentFromStore } from '../../../../../flows/src/components/ui/common/hooks/useTagContent';

interface Props {
  isSelection: boolean;
  currentTag?: string;
  nextTag?: string;
  position: number;
}

const QuestionViewText: React.FC<React.PropsWithChildren<Props>> = ({
  isSelection,
  currentTag,
  nextTag,
  position,
}) => {
  const { t } = useTranslation();
  const isFinalizeQuestionsView =
    window.location.pathname.includes('/finalize');
  const location = useLocation();
  const selectionContent = [
    t('Choose risk objects'),
    t('Choose companies'),
    t('Choose guarantees'),
  ];

  const capitalize = (text: string): string =>
    text?.charAt(0)?.toUpperCase() + text?.slice(1);

  if (location.pathname.match(new RegExp('/product/session/finalize.*')))
    return <div></div>;

  return (
    <div>
      <Text color="secondary.300" fontWeight="bold">
        {isSelection
          ? capitalize(selectionContent[position]) ||
            capitalize(selectionContent[2])
          : currentTag
          ? getTagContentFromStore(currentTag) ||
            t(`FLOWS_TOOLBAR_${currentTag}`)
          : t('FINALIZATION')}
      </Text>
      {((!isSelection && nextTag) || (isSelection && position < 2)) &&
        !isFinalizeQuestionsView && (
          <Text fontSize="sm" color="secondary.100">
            {t('Next')}:{' '}
            {isSelection
              ? capitalize(selectionContent[position + 1])
              : capitalize(
                  (nextTag && getTagContentFromStore(nextTag)) ||
                    t(`FLOWS_TOOLBAR_${nextTag}`),
                )}
          </Text>
        )}
    </div>
  );
};

export default QuestionViewText;
